import type { ReactNode } from "react";

type Kind = "ok" | "warn" | "danger" | "info" | "muted" | "violet";

export function Pill({ kind = "muted", children }: { kind?: Kind; children: ReactNode }) {
  return <span className={`t-pill ${kind}`}>{children}</span>;
}
